import React from'react'
import {ReactComponent as PlayIcon} from '../svgs/play.svg';
import Categories from './Categories';
import {Route, Routes} from 'react-router-dom';
import PlaylistPage from './pages/Playlist';

const Main = () => {
  return (
     <div className="main">
      <div className="upperNav">Debo's Spotify UI Design</div>
      <div className="mainContent">
        <Routes>
          <Route path='/' element={<Categories/>} />
          <Route path='/search'/>
          Search
          <Route path='/your-library'/> 
          Your Library
          <Route path='/playlist/:id' element={<PlaylistPage/>}/>
          </Routes>
        </div> 
       </div>
      )
      }

      export default Main

      